import { j as jsxRuntimeExports } from "./auth-service-tools177.js";
import { forwardRef } from "react";
import { clsx } from "./auth-service-tools193.js";
import { FocusTrap } from "./auth-service-tools274.js";
import { Paper } from "./auth-service-tools262.js";
import { Transition } from "./auth-service-tools276.js";
import { useModalBaseContext } from "./auth-service-tools286.js";
import classes from "./auth-service-tools290.js";
const ModalBaseContent = /*#__PURE__*/forwardRef((_ref, ref) => {
  let {
    transitionProps,
    className,
    innerProps,
    onKeyDown,
    style,
    ...others
  } = _ref;
  const ctx = useModalBaseContext();
  return /* @__PURE__ */jsxRuntimeExports.jsx(Transition, {
    mounted: ctx.opened,
    transition: "pop",
    ...ctx.transitionProps,
    ...transitionProps,
    children: transitionStyles => /* @__PURE__ */jsxRuntimeExports.jsx("div", { ...innerProps,
      className: clsx({
        [classes.inner]: !ctx.unstyled
      }, innerProps.className),
      children: /* @__PURE__ */jsxRuntimeExports.jsx(FocusTrap, {
        active: ctx.opened && ctx.trapFocus,
        innerRef: ref,
        children: /* @__PURE__ */jsxRuntimeExports.jsx(Paper, { ...others,
          component: "section",
          role: "dialog",
          tabIndex: -1,
          "aria-modal": true,
          "aria-describedby": ctx.bodyMounted ? ctx.getBodyId() : void 0,
          "aria-labelledby": ctx.titleMounted ? ctx.getTitleId() : void 0,
          style: [style, transitionStyles],
          className: clsx({
            [classes.content]: !ctx.unstyled
          }, className),
          unstyled: ctx.unstyled,
          children: others.children
        })
      })
    })
  });
});
ModalBaseContent.displayName = "@mantine/core/ModalBaseContent";
export { ModalBaseContent };